import { vertexAI } from "../firebaseConfig";


class VertexAIService {
  constructor() { 
    // Puedes inicializar propiedades de la clase aquí si es necesario
  }

  async enviarTexto(texto, parametros = {}) {
    try {
      // Verifica si el texto está vacío
      if (!texto || texto.trim() === "") {
        console.warn("No se puede enviar un texto vacío a Vertex AI");
        return "Error: Texto vacío";
      }

      // Obtiene la instancia del modelo
      const model = vertexAI.generativeModel("text-bison@001"); 

      // Envía la solicitud a Vertex AI con un timeout de 15 segundos
      const response = await model.generateContent({ 
        prompt: texto,
        ...parametros,
      }, { timeoutMillis: 15000 }); 

      // Verifica si hay respuesta
      if (!response || !response.text) {
        console.warn("No se recibió una respuesta válida de Vertex AI");
        return "Error: No se recibió respuesta";
      }

      console.log("Respuesta de Vertex AI:", response.text);
      return response.text; 
    } catch (error) {
      console.error("Error al enviar texto a Vertex AI:", error);

      // Manejo de errores más específico
      if (error.code === "vertexai/timeout") {
        console.error("La solicitud a Vertex AI excedió el tiempo límite");
        return "Error: Tiempo de espera agotado";
      } else if (error.code === "vertexai/unavailable") {
        console.error("Vertex AI no está disponible en este momento");
        return "Error: Servicio no disponible";
      } else {
        console.error("Error desconocido de Vertex AI:", error);
        return "Error: Error desconocido";
      }
    }
  }
}

const vertexAIServiceInstance = new VertexAIService(); 
export default vertexAIServiceInstance;